import { useReduxState } from 'hooks';

interface Props {
  borderColor?: string;
  children?: React.ReactNode;
  padding?: string | number;
}

const BoxRow = ({ borderColor, children, padding }: Props) => {
  const { theme } = useReduxState();

  return (
    <div
      className="box-row"
      style={{ padding: padding !== undefined ? padding : '10px 15px' }}
    >
      {children}

      <style jsx>{`
        .box-row {
          color: ${theme.textColor};
          font-size: 1.5rem;
        }
        .box-row:not(:first-child) {
          border-top: 1px solid ${borderColor || theme.lightGrey};
        }
      `}</style>
    </div>
  );
};

export default BoxRow;
